<template>
  <div>
    <common-dialog
      ref="dialog"
      width="720px"
      :show-save-button="!readonly"
      unit="学生请假"
      id-key="LeaveId"
      :data="data"
      form-label-width="85px"
      :form-rules="data.SectionMode==0?rules:rules2"
      :save-func="isEdit?api.saveV2:api.saveMultiV2"
      :get-data-func="api.info"
      :before-save="data.SectionMode==0?onBeforeSave:onBeforeSave2"
      @edit-opened="onEditOpened"
      @create-opened="onCreateOpened"
      @close-saved="$emit('close-saved')"
      @closed="onClosed"
    >
      <template slot="form">
        <el-row>
          <el-col :span="isMB?24:12">
            <el-form-item label="学期名称" prop="TermId" class="longLabel">
              <el-select
                :disabled="readonly||isEdit"
                v-model="data.TermId"
                size="mini"
                @change="termChange"
                style="width:100%;"
              >
                <el-option
                  v-for="item in termList"
                  :key="item.TermId"
                  :value="item.TermId"
                  :label="item.TermName"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="isMB?24:12">
            <el-form-item label="节次类型" prop="SectionType" class="longLabel">
              <el-select
                :disabled="readonly||isEdit"
                v-model="data.SectionType"
                size="mini"
                @change="stChange"
                style="width:100%;"
              >
                <el-option label="上课节次" :value="0"></el-option>
                <el-option label="留宿节次" :value="1"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24" v-if="isEdit">
            <el-form-item label="学生姓名" prop="FullName" class="longLabel">
              <el-input
                size="mini"
                type="text"
                v-model="data.FullName"
                placeholder=""
                disabled
                style="width:100%"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24" v-else>
            <el-form-item label="学生姓名" prop="FullName" class="longLabel">
              <el-input
                size="mini"
                type="textarea"
                v-model="data.FullName"
                placeholder="点击选择"
                readonly
                @focus="onSTCDialog"
                style="width:100%"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="isMB?24:12">
            <el-form-item label="节次模式" prop="SectionMode" class="longLabel">
              <el-select v-model="data.SectionMode" size="mini" @change="modeChange" :disabled="isEdit" style="width:100%;">
                <el-option :value="0" label="连续节次"></el-option>
                <el-option :value="1" label="固定节次"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="isMB?24:12">
            <el-form-item label="请假类型" prop="LeaveType" class="longLabel">
              <el-select v-model="data.LeaveType" placeholder="请选择请假类型" :disabled="pass" @change="typeChange" size="mini" style="width:100%;">
                <el-option v-for="(item,index) in typeList" :key="index" :value="item"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="isMB?24:12" v-if="data.LeaveMode==2&&showDate">
            <el-form-item label="请假开始日期" prop="StartDate" class="longLabel">
              <el-date-picker
                v-if="ready&&data.SectionMode==0"
                v-model="data.StartDate"
                :disabled="pass"
                value-format="yyyy/MM/dd"
                size="mini"
                style="width:100%"
                @change="editCheckSection(1)"
                :picker-options="contestOptions"
                placeholder="请选择开始时间"
              ></el-date-picker>
              <el-date-picker
                v-else-if="ready"
                v-model="data.StartDate"
                :disabled="pass"
                value-format="yyyy/MM/dd"
                size="mini"
                style="width:100%"
                @change="editCheckSection(1)"
                :picker-options="contestOptions2"
                placeholder="请选择开始时间"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="isMB?24:12" v-else-if="showDate">
            <el-form-item label="请假开始日期" prop="StartDate" class="longLabel">
              <el-date-picker
                v-if="ready&&data.SectionMode==0"
                v-model="data.StartDate"
                :disabled="pass"
                value-format="yyyy/MM/dd"
                size="mini"
                style="width:100%"
                @change="editCheckSection(1)"
                placeholder="请选择开始时间"
                :picker-options="isEdit?pickerOptions:true"
              ></el-date-picker>
              <el-date-picker
                v-else-if="ready"
                v-model="data.StartDate"
                :disabled="pass"
                value-format="yyyy/MM/dd"
                size="mini"
                style="width:100%"
                @change="editCheckSection(1)"
                placeholder="请选择开始时间"
                :picker-options="isEdit?pickerOptions:true"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="isMB?24:12" v-if="data.SectionMode==0">
            <el-form-item label="开始节次" prop="StartSectionId" class="longLabel">
              <el-select v-model="data.StartSectionId" size="mini" :disabled="pass" placeholder="请选择" @change="editCheckSection(1)" style="width:100%;">
                <el-option
                  v-for="item in sectionList"
                  :key="item.SectionId"
                  :value="item.SectionId"
                  :label="item.SectionName"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="isMB?24:12" v-if="data.LeaveMode==2&&showDate">
            <el-form-item label="请假结束日期" prop="EndDate" class="longLabel">
              <el-date-picker
                v-if="ready&&data.SectionMode==0"
                v-model="data.EndDate"
                :disabled="readonly"
                value-format="yyyy/MM/dd"
                size="mini"
                style="width:100%;"
                @change="editCheckSection(2)"
                :picker-options="contestOptions"
                placeholder="请选择结束时间"
              ></el-date-picker>
              <el-date-picker
                v-else-if="ready"
                v-model="data.EndDate"
                :disabled="readonly"
                value-format="yyyy/MM/dd"
                size="mini"
                @change="editCheckSection(2)"
                style="width:100%;"
                placeholder="请选择结束时间"
                :picker-options="contestOptions2"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="isMB?24:12" v-else-if="showDate">
            <el-form-item label="请假结束日期" prop="EndDate" class="longLabel">
              <el-date-picker
                v-if="ready&&data.SectionMode==0"
                v-model="data.EndDate"
                :disabled="readonly"
                value-format="yyyy/MM/dd"
                size="mini"
                @change="editCheckSection(2)"
                style="width:100%;"
                placeholder="请选择结束时间"
                :picker-options="isEdit?pickerOptions:true"
              ></el-date-picker>
              <el-date-picker
                v-else-if="ready"
                v-model="data.EndDate"
                :disabled="readonly"
                value-format="yyyy/MM/dd"
                size="mini"
                @change="editCheckSection(2)"
                style="width:100%;"
                placeholder="请选择结束时间"
                :picker-options="isEdit?pickerOptions:true"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="isMB?24:12" v-if="data.SectionMode==0">
            <el-form-item label="结束节次" prop="EndSectionId" class="longLabel">
              <el-select v-model="data.EndSectionId" size="mini" :disabled="readonly" placeholder="请选择" @change="editCheckSection(2)" style="width:100%;">
                <el-option
                  v-for="item in sectionList"
                  :key="item.SectionId"
                  :value="item.SectionId"
                  :label="item.SectionName"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24" v-if="data.SectionMode==1&&showMult">
            <el-form-item label="周期" prop="WeekDays" class="longLabel">
              <el-select v-model="WeekDays" multiple @change="dayChange" :disabled="pass||isEdit" size="mini" style="width:100%">
                <el-option
                  v-for="item in dayList"
                  :key="item"
                  :value="item"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24" v-if="data.SectionMode==1&&showMult">
            <el-form-item label="固定节次" prop="sIds" class="longLabel">
              <el-select v-model="data.sIds" multiple :disabled="pass" size="mini" style="width:100%">
                <el-option
                  v-for="item in sectionList"
                  :key="item.SectionId"
                  :value="item.SectionId"
                  :label="item.SectionName"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-form-item label="备注" prop="Remark" class="longLabel">
            <el-input size="mini" type="textarea" style="width:100%" :disabled="pass" v-model="data.Remark" :placeholder="data.LeaveMode==2?'请注明科目及类型':'请填写备注'"></el-input>
          </el-form-item>
        </el-row>
        <el-form-item label="" class="longLabel">
          <el-tag type="primary" v-for="(item,index) in tagList" size="small" class="tag" :key="item" @click="tagClick(item,index)"
            :style="isMB?'margin-bottom: 10px;':(index==0?'margin-bottom: 10px;':'')">
            <span style="vertical-align: 1px;">{{tagNum(index)}}</span>
            {{item}}
          </el-tag>
        </el-form-item>
      </template>
      <leavedts ref="leavedts" v-if="isEdit&&data.SectionMode==1" @loaded="loaded" :leaveid="data.LeaveId" />
      <template #footer>
        <el-button size="mini" type="primary" style="float:left;" v-if="isEdit" @click="copy">复制修改另存</el-button>
        <el-button size="mini" @click="close" v-if="readonly">关 闭</el-button>
      </template>
    </common-dialog>
    <stc-dialog ref="stcDialog" v-if="ready" in-dialog selectable :multiple="!isEdit" @select="setSTC" @select-multiple="setSTCmul" :st-params="stParams" />
  </div>
</template>
<script>
let loginInfo = JSON.parse(localStorage.getItem("loginInfo"));

import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import termApi from "@/api/ed/term";
import stcDialog from "@/components/st/sc/listDialog";
import leavedts from "./leavedts";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    stcDialog,
    leavedts
  },
  computed: {
    tagList() {
      switch (this.data.LeaveType) {
        case "病假":
          return ["感冒（体温≧38℃）","感冒（体温<38℃）","肠胃不适（拉肚子、呕吐、胃痛等）","外伤：","调整","其他："];
        case "事假":
          return ["家里有事：","艺考、港澳籍等","防疫1在家","防疫2隔离宿舍","防疫3隔离酒店","防疫4在医院","其他："];
        case "走读":
          return ["肠胃调理","调整","其他："];
        case "公假":
          return ["参加竞赛等","学生活动（团委、社团工作）","其他："];
        case "校本课程":
          return ["培优加强","竞赛训练"];
        case "校内其他":
          return ["学生活动（团委、社团工作）","其他："];
        default:
          return [];
      }
    },
    now() {
      var date = new Date();
      return date.getTime();
    },
  },
  watch: {
    
  },
  data() {
    return {
      data: {
        StudentIds: [],
        LeaveId: 0,
        SectionId: 0,
        StudentId: 0,
        FullName: "",
        TeacherId: null,
        TermId: null,
        TermNumber: "",
        StartDate: "",
        EndDate: "",
        StartSectionId: null,
        StartSection: "",
        EndSectionId: null,
        EndSection: "",
        LeaveType: "",
        LeaveMode: 0,
        SectionIds: "",
        SectionNames: "",
        Status: "正常",
        ClassId: 0,
        GradeId: 0,
        SectionMode: 0,
        SectionType: 0,
        WeekDays: "",
        Remark: "",
        sIds: [],
        StartSectionEndTime: "",
      },
      isEdit: false,
      readonly: false,
      ready: false,
      pass: false,
      showDate: true,
      WeekDays: ["星期一","星期二","星期三","星期四","星期五","星期六","星期日"],
      api: require("@/api/st/leave").default,
      sectionApi: require("@/api/ed/section").default,
      termApi,
      termList: [],
      typeList: ["病假", "事假","走读", "公假", "校本课程", "校内其他"],
      showMult: true,
      sectionList: [],
      isMB: this.$store.state.isMB,
      startLimit: "",
      endLimit: "",
      dayList: ["星期一","星期二","星期三","星期四","星期五","星期六","星期日"],
      stParams: {
        GradeId: loginInfo.GradeId,
        ClassId: loginInfo.ClassId,
      },
      rules: {
        FullName: [{ required: true, message: "请选择学生" }],
        SectionMode: [{ required: true, message: "请选择节次模式" }],
        TermId: [{ required: true, message: "请选择学期" }],
        SectionType: [{ required: true, message: "请选择节次类型" }],
        StartDate: [{ required: true, message: "请选择开始时间" }],
        EndDate: [{ required: true, message: "请选择结束时间" }],
        StartSectionId: [{ required: true, message: "请选择开始节次" }],
        EndSectionId: [{ required: true, message: "请选择结束节次" }],
        LeaveType: [{ required: true, message: "请选择请假类型" }],
        Remark: [{ required: true, message: "备注不能为空" }],
      },
      rules2: {
        FullName: [{ required: true, message: "请选择学生" }],
        SectionMode: [{ required: true, message: "请选择节次模式" }],
        TermId: [{ required: true, message: "请选择学期" }],
        SectionType: [{ required: true, message: "请选择节次类型" }],
        StartDate: [{ required: true, message: "请选择开始时间" }],
        EndDate: [{ required: true, message: "请选择结束时间" }],
        WeekDays: [{ required: true, message: "请选择周期" }],
        sIds: [{ required: true, message: "请选择固定节次" }],
        LeaveType: [{ required: true, message: "请选择请假类型" }],
        Remark: [{ required: true, message: "备注不能为空" }],
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 86400000;
        },
      },
      pickerOptions2: {
        disabledDate(time) {
          return time.getTime() < Date.now();
        },
      },
      contestOptions: this.po(Date.now()),
      contestOptions2: this.po2(Date.now()),
    };
  },
  methods: {
    onCreateOpened(data) {
      this.getOption();
      this.data.StartDate = this.$commonJs.getToday();
      this.data.TeacherId = loginInfo.TeacherId;
      if (loginInfo.TermId > 0) this.data.TermId = loginInfo.TermId;
      else this.data.TermId = Number(sessionStorage.getItem("termId"));
      if (data) {
        this.getSection(data);
      }
      this.contestOptions = this.po();
      this.contestOptions2 = this.po();
      this.data.WeekDays = "星期一,星期二,星期三,星期四,星期五,星期六,星期日";
    },
    onEditOpened(row) {
      this.isEdit = true;
      this.data.StartDate = this.$commonJs.toDateString(row.StartDate);
      this.data.EndDate = this.$commonJs.toDateString(row.EndDate);
      this.getOption();
      // this.readonly = row.SectionMode==0?this.now>this.getTime(row.StartSectionEndTime):false;
      this.readonly = this.getTime(this.$commonJs.getToday()) > this.getTime(row.EndDate);
      this.pass = this.getTime(this.$commonJs.getToday()) > this.getTime(row.StartDate);
      if(row.WeekDays) {
        this.WeekDays = row.WeekDays.split(",");
      }
      if(row.SectionMode==0) {
        this.getSection(row,true);
      } else {
        this.getSection(row);
      }
      if(row.SectionMode==0) {
        this.contestOptions = this.po(this.getTime(row.CreateTime));
      } else {
        this.contestOptions2 = this.po2(this.getTime(row.CreateTime));
      }
    },
    loaded(time) {
      // if(time&&!this.readonly) {
      //   this.readonly = this.now > this.getTime(time);
      // }
    },
    getTime(time) {
      if(time) {
        var date = new Date(time);
        var rs = date.getTime();
        if(rs) {
          return date.getTime();
        } else {
          time = time.replace(/\-/g, '/');
          date = new Date(time);
          return date.getTime();
        }
      } else {
        return 0
      }
    },
    getOption() {
      this.ready = true;
      this.termApi.list().then((res) => {
        this.termList = res.Data || [];
        res.Data.forEach((item) => {
          if (this.data.TermId == item.TermId) {
            this.startLimit = item.StartTime;
            this.endLimit = item.EndTime;
          }
        });
      });
    },
    getSection(data,type) {
      var TermId = data.TermId;
      var GradeId = data.GradeId;
      if (TermId && GradeId) {
        this.loading(true);
        this.sectionApi.list({ TermId, GradeId, SectionType: this.data.SectionType }).then((res) => {
          this.loading(false);
          this.sectionList = res.Data;
          if(data.SectionMode==1&&data.SectionIds) {
            var arr = data.SectionIds.split(",");
            arr.forEach(e => {
              this.data.sIds.push(Number(e));
            })
          }
          if(type) {
            var lastTime = res.Data[res.Data.length-1].StartTime;
            var today = this.$commonJs.getToday();
            if(this.readonly && this.getTime(this.$commonJs.getToday()) == this.getTime(this.data.EndDate)) {
              res.Data.forEach(e => {
                if(e.SectionId == this.data.EndSectionId) {
                  if(this.now < this.getTime(today + " " + e.StartTime + ":00") && this.now < this.getTime(today + " " + lastTime + ":00")) {
                    this.readonly = false;
                  }
                  return;
                }
              })
            }
            if(this.pass && this.getTime(this.$commonJs.getToday()) == this.getTime(this.data.StartDate)) {
              res.Data.forEach(e => {
                if(e.SectionId == this.data.StartSectionId) {
                  if(this.now < this.getTime(today + " " + e.StartTime + ":00") && this.now < this.getTime(today + " " + lastTime + ":00")) {
                    this.pass = false;
                  }
                  return;
                }
              })
            }
          }
        });
      }
    },
    onBeforeSave() {
      if (this.data.StartDate.split(" ")[0] == this.data.EndDate.split(" ")[0]) {
        let index1 = null;
        let index2 = null;
        this.sectionList.forEach((e, index) => {
          if (this.data.StartSectionId == e.SectionId) {
            index1 = index;
          }
          if (this.data.EndSectionId == e.SectionId) {
            index2 = index;
          }
        });
        if (index1 > index2) {
          this.$message.error("当天申请的，开始节次不得在结束节次之后");
          return false;
        }
      }
      if (this.data.StartDate > this.data.EndDate) {
        this.$message.error("开始时间不能大于结束时间");
        return false;
      }
      var sl = (new Date(this.startLimit)).getTime();
      var el = (new Date(this.endLimit)).getTime();
      var sd = (new Date(this.data.StartDate)).getTime();
      var ed = (new Date(this.data.EndDate)).getTime();
      if (sd < sl || ed > el) {
        this.$message.error("申请时间不在所选学期范围内");
        return false;
      }
    },
    onBeforeSave2() {
      if (this.data.StartDate > this.data.EndDate) {
        this.$message.error("开始时间不能大于结束时间");
        return false;
      }
      var sl = (new Date(this.startLimit)).getTime();
      var el = (new Date(this.endLimit)).getTime();
      var sd = (new Date(this.data.StartDate)).getTime();
      var ed = (new Date(this.data.EndDate)).getTime();
      if (sd < sl || ed > el) {
        this.$message.error("申请时间不在所选学期范围内");
        return false;
      }
      if(!this.data.StartSectionId) {
        this.data.StartSectionId = 0;
      }
      if(!this.data.EndSectionId) {
        this.data.EndSectionId = 0;
      }
      var arr = [this.data.sIds[0]];
      var sn = [];
      var sl = this.sectionList;
      this.data.sIds.forEach(e => {
        sl.forEach(n => {
          if(n.SectionId == e) {
            sn.push(n.SectionNumber);
          }
        })
      });
      if(sn.length == this.data.sIds.length) {
        var sn0 = [sn[0]];
        for (let i = 1; i < sn.length; i++) {
          var index = 0;
          for (let j = 0; j < sn0.length; j++) {
            if(sn[i] > sn0[j]) {
              index = j+1
            }
          }
          sn0.splice(index,0,sn[i]);
          arr.splice(index,0,this.data.sIds[i]);
        }
        this.data.sIds = arr;
        this.data.SectionNames = "";
        this.data.SectionIds = "";
        this.data.sIds.forEach((e,index) => {
          this.sectionList.forEach(n => {
            if(e == n.SectionId) {
              this.data.SectionNames += n.SectionName;
              this.data.SectionIds += n.SectionId;
              if(this.data.sIds.length != index+1) {
                this.data.SectionNames += ",";
                this.data.SectionIds += ",";
              }
            }
          })
        })
      }
    },
    copy() {
      this.data.LeaveId = 0;
      this.isEdit = false;
      this.readonly = false;
      this.pass = false;
      this.ready = false;
      this.data.StudentIds = [this.data.StudentId];
      this.$message.success("复制修改成功");
      this.$nextTick(() => {
        this.ready = true;
      })
    },
    termChange(e) {
      this.termList.forEach((item) => {
        if (e == item.TermId) {
          this.startLimit = item.StartTime;
          this.endLimit = item.EndTime;
          // this.data.StudentId = null;
          this.data.StudentIds = [];
          this.data.FullName = null;
          this.data.StartSectionId = null;
          this.data.EndSectionId = null;
          this.sectionList = [];
          this.data.sIds = [];
          this.data.SectionIds = "";
          this.data.SectionNames = "";
        }
      });
    },
    modeChange(e) {
      this.showMult = false;
      this.data.SectionNames = "";
      this.data.SectionIds = "";
      this.data.sIds = [];
      this.data.StartSectionId = null;
      this.data.EndSectionId = null;
      this.$nextTick(() => {
        this.showMult = true;
      });
    },
    onSTCDialog() {
      this.$refs.stcDialog.open().then((that) => {
        that.getDataWithClass(this.data.TermId, this.data.TeacherId);
        that.showForm();
      });
    },
    setSTC(stc) {
      this.data.StudentId = stc.StudentId;
      this.data.FullName = stc.FullName;
      this.data.ClassId = stc.ClassId;
      if (stc.GradeId != this.data.GradeId) {
        this.data.GradeId = stc.GradeId;
        this.getSection({ TermId: this.data.TermId, GradeId: stc.GradeId });
        this.data.StartSectionId = null;
        this.data.EndSectionId = null;
        this.data.SectionIds = "";
        this.data.sIds = [];
        this.data.SectionNames = "";
      }
    },
    setSTCmul(stcm) {
      if(stcm.length == 0) {
        return;
      } else {
        var stc = stcm[0];
        this.data.GradeId = stc.GradeId;
        if(this.sectionList.length == 0) {
          this.getSection({ TermId: this.data.TermId, GradeId: stc.GradeId });
        } else if(stc.GradeId != this.data.GradeId) {
          this.data.GradeId = stc.GradeId;
          this.getSection({ TermId: this.data.TermId, GradeId: stc.GradeId });
          this.data.StartSectionId = null;
          this.data.EndSectionId = null;
          this.data.SectionIds = "";
          this.data.sIds = [];
          this.data.SectionNames = "";
          this.resetST();
        }
      }
      //----------------------------------
      // var first = true;
      this.resetST();
      stcm.forEach((e,index) => {
        if(this.data.StudentIds.indexOf(e.StudentId) == -1) {
          // if(first && this.data.StudentIds.length > 0) {
          //   this.data.FullName += ","
          //   first = false;
          // }
          this.data.StudentIds.push(e.StudentId);
          this.data.FullName += e.FullName;
          if(stcm.length > index + 1) {
            this.data.FullName += "，";
            // first = false;
          }
        }
      })
    },
    resetST() {
      this.data.FullName = "";
      this.data.StudentIds = [];
    },
    editCheckSection(type) {
      if(this.data.SectionMode == 1 || !this.data.LeaveId) return;
      var today = this.$commonJs.getToday();
      if(type==1) {
        if(this.data.StartDate == today &&this.data.StartSectionId) {
          this.sectionList.forEach(e => {
            if(e.SectionId == this.data.StartSectionId) {
              if(this.now > this.getTime(today + " " + e.EndTime + ":00")) {
                this.$message.error("当天请假的对应节次已经结束");
                this.data.StartSectionId = null;
              }
              return;
            }
          })
        }
      } else {
        if(this.data.EndDate == today &&this.data.EndSectionId) {
          this.sectionList.forEach(e => {
            if(e.SectionId == this.data.EndSectionId) {
              if(this.now > this.getTime(today + " " + e.EndTime + ":00")) {
                this.$message.error("当天请假的对应节次已经结束");
                this.data.EndSectionId = null;
              }
              return;
            }
          })
        }
      }
    },
    dayChange(v) {
      this.data.WeekDays = v.join(",");
    },
    typeChange(v) {
      this.showDate = false;
      switch (v) {
        case "病假":
          this.data.LeaveMode = 0;
          break;
        case "事假":
          this.data.LeaveMode = 0;
          break;
        case "走读":
          this.data.LeaveMode = 1;
          break;
        case "公假":
          this.data.LeaveMode = 0;
          break;
        case "校本课程":
          this.data.LeaveMode = 2;
          this.data.StartDate = "";
          this.data.EndDate = "";
          break;
        case "校内其他":
          this.data.LeaveMode = 0;
          break;
      }
      this.$nextTick(() => {
        this.showDate = true;
      })
    },
    po(t = Date.now()) {
      var self = this;
      return {
        disabledDate(time) {
          var p1 = time.getTime() > t + 1000 * 3600 * 24 * 6 || time.getTime() < new Date(self.$commonJs.getToday()).getTime() - 24 * 3600 * 1000;
          return p1;
        }
      }
    },
    po2(t = Date.now()) {
      var self = this;
      return {
        disabledDate(time) {
          var p2 = time.getTime() > t + 1000 * 3600 * 24 * 6 || time.getTime() < new Date(self.$commonJs.getToday()).getTime();
          return p2;
        }
      }
    },
    stChange() {
      this.data.SectionNames = "";
      this.data.SectionIds = "";
      this.data.sIds = [];
      this.data.StartSectionId = null;
      this.data.EndSectionId = null;
      this.getSection(this.data);
    },
    tagClick(item,index) {
      if(!this.pass) this.data.Remark += this.tagNum(index)+item;
    },
    onClosed() {
      this.data.sIds = [];
      this.sectionList = [];
      this.WeekDays = ["星期一","星期二","星期三","星期四","星期五","星期六","星期日"];
      this.isEdit = false;
      this.readonly = false;
      this.ready = false;
      this.pass = false;
      this.showDate = true;
      this.resetST();
    },
    tagNum(index) {
      switch (index) {
        case 0:
          return "①";
        case 1:
          return "②";
        case 2:
          return "③";
        case 3:
          return "④";
        case 4:
          return "⑤";
        case 5:
          return "⑥";
        case 6:
          return "⑦";
      }
    },
  }
};
</script>
<style lang="scss">
.tag {
  font-size:12px;
  cursor:pointer;
  margin: 0px 10px 0px 0;
}
</style>